export const ACQUISITION_REPORT_LIMIT = 500
export const ACQUISITION_TTL_MS = 30 * 24 * 60 * 60 * 1000
export const ACQUISITION_RETENTION_MS = 90 * 24 * 60 * 60 * 1000
export const ACQUISITION_TOKEN = /^[a-f0-9]{64}$/
export const CAMPAIGN_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const
export type CampaignAttribution = Partial<Record<(typeof CAMPAIGN_KEYS)[number], string>>
export type AcquisitionEvent = 'landing' | 'signup_started'

// Campaign labels, never entire URLs, free text, auth tokens, or donor data.
export function campaignAttribution(search: string): CampaignAttribution {
  const params = new URLSearchParams(search)
  return Object.fromEntries(CAMPAIGN_KEYS.flatMap(key => {
    const value = params.get(key)?.trim()
    return value && /^[a-zA-Z0-9_. -]{1,120}$/.test(value) ? [[key, value]] : []
  }))
}

export function isAcquisitionPath(path: string) {
  return path === '/' || path === '/signup' || path === '/agencies' || path === '/agencies/' || /^\/(features|solutions|pricing|compare|integrations|wordpress-plugin|about|contact-sales|privacy|terms|blog|resources|tools|editorial-standards)(\/|$)/.test(path)
}

export function isProductionMarketingHost(hostname: string) {
  return hostname === 'www.kindlumen.com' || hostname === 'kindlumen.com'
}

export function safeMarketingUrl(url: URL) {
  if (!isAcquisitionPath(url.pathname) || !/^[a-z0-9/_.-]*$/i.test(url.pathname)) return false
  if (url.hash && !['#how-it-works'].includes(url.hash)) return false
  return [...url.searchParams].every(([key, value]) =>
    key === 'fbclid' ? /^[a-zA-Z0-9_-]{1,500}$/.test(value) :
      CAMPAIGN_KEYS.includes(key as (typeof CAMPAIGN_KEYS)[number]) && /^[a-zA-Z0-9_. -]{1,120}$/.test(value),
  )
}
